import { type FC, useMemo } from 'react';

import { RenderingProvider, useCms, useContent } from '@eneco/cms';
import { Box, NavLink, PageGrid, Stack } from '@eneco/sparky';

import type { RegistrationFooterContent } from './registration-footer-content.types';

const RegistrationFooterInner = () => {
  const content = useContent<RegistrationFooterContent>();

  return (
    <Box backgroundColor="backgroundPrimary" paddingY="3">
      <PageGrid>
        <PageGrid.Item gridColumn="1/-1">
          <Stack direction="row" alignX="end">
            <NavLink href={content.privacyStatementLink?.href} variant="secondary">
              {content.privacyStatementLink?.text}
            </NavLink>
          </Stack>
        </PageGrid.Item>
      </PageGrid>
    </Box>
  );
};

interface RegistrationFooterProps {
  fields?: unknown;
  params?: Record<string, string>;
  placeholders?: Record<string, unknown[]>;
  componentName?: string;
  uid?: string;
}

const RegistrationFooter: FC<RegistrationFooterProps> = ({ fields, params, placeholders, componentName, uid }) => {
  const { adapter } = useCms();
  const rendering = useMemo(
    () =>
      adapter.toRendering({
        componentName: componentName ?? 'RegistrationFooter',
        uid,
        fields,
        params,
        placeholders,
      }),
    [adapter, fields, params, placeholders, componentName, uid],
  );

  return (
    <RenderingProvider rendering={rendering}>
      <RegistrationFooterInner />
    </RenderingProvider>
  );
};

export default RegistrationFooter;
